import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  fontFamilies,
  palette,
  lineHeights,
  fontSizes,
  breakpoints,
}: Theme) => ({
  formControlRoot: {},
  formControlLabelRoot: {
    minWidth: 'unset',
    margin: '0 0 18px',
    alignItems: 'flex-start',
    '& .MuiTypography-root': {
      minWidth: 'unset',
    },
  },
  formControlRootIconType: {
    margin: 0,
  },
  formControlLabelLabel: {
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.sm,
    fontFamily: fontFamilies.primary,
    color: palette.text.secondary,
    paddingTop: 2,
    '& a': {
      color: palette.primary.dark,
    },
    '& a sup': {
      display: 'inline-block',
    },
  },
  checkboxRoot: {
    padding: 0,
    marginRight: 4,
    '&$checkboxRoot:hover': {
      backgroundColor: 'transparent',
    },
    [breakpoints.up('md')]: {
      marginRight: 12,
    },
  },
  checkboxRootIcontype: {
    marginRight: 0,
  },
  formHelperTextRoot: {
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.sm,
    fontFamily: fontFamilies.primary,
    color: palette.text.secondary,
    margin: '0 0 18px',
    '&$formHelperTextError': {
      color: palette.error.main,
    },
    [breakpoints.up('md')]: {
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.md,
    },
  },
  formHelperTextError: {},
}));
